export const historyEn = {
  title: 'Our Journey',
  timeline: [
    {
      date: '12/2024',
      content: `<span>
          Achieved a major milestone: <b>150+ projects</b> completed across North America, with 
          <b>a total capacity exceeding 500MWh</b>, solidifying our leadership in the energy storage sector.
        </span>`,
    },
    {
      date: '01/2023',
      content: `<span>
          Launched <b>CARUS Energy</b>, expanding our expertise in <b>end-to-end EPC solutions</b> for diverse energy
          applications.
        </span>`,
    },
    {
      date: '09/2017',
      content: `<span>
          Completed our first North American project in <b>Hawaii</b> (720kW/1.44MWh), reinforcing our commitment to
          sustainable energy deployment.
        </span>`,
    },
    {
      date: '03/2017',
      content: `<span>
          Successfully commissioned our first energy storage project in Hefei, China (1MW/4.4MWh), marking our entry
          into the global renewable energy market.
        </span>`,
    },
    {
      date: '2016',
      content: `<span>Founded EPC Energy in San Jose, California, specializing in innovative energy solutions.</span>`,
    },
  ],
}
